import { EventParentalControlRating } from 'services/data-manager/types';

export default function getParentalRatingNumber(
    parentalRating: EventParentalControlRating | number | undefined,
): number | undefined {
    if (parentalRating !== undefined) {
        if (typeof parentalRating === 'number') {
            return parentalRating;
        }

        if (
            ![
                EventParentalControlRating.HU6,
                EventParentalControlRating.HU12,
                EventParentalControlRating.HU16,
                EventParentalControlRating.HU18,
                EventParentalControlRating.HU18_ADULT,
                EventParentalControlRating.HU18_ADULT_UC,
            ].includes(parentalRating)
        ) {
            return undefined;
        }

        const parentalRatingNumber = +parentalRating.substring(3, 5);

        if (Number.isNaN(parentalRatingNumber)) {
            return undefined;
        }

        return +parentalRatingNumber;
    }

    return undefined;
}
